import axios from "axios";

const API_BASE_URL = "https://space.star69.co";

// Create axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

// API service functions
export const fetchProviderList = () => {
  return api.get("/bfx-game-list.json");
};

export default api;
